import { JsonObject } from 'core/types';
import { AuthorityName, ModuleName } from '@fides/fides-react-components';

export class Authority {
  public name: AuthorityName;
  public module: ModuleName;
  public privilege: number;
  constructor(json: JsonObject) {
    this.name = json.authority;
    this.module = json.module;
    this.privilege = json.privilege;
  }

  get authority(): AuthorityName {
    return this.name;
  }
}
